import styled from "@emotion/styled";
import {  Form } from "antd";
import TextArea from "antd/es/input/TextArea";
import { InfoCircleOutlined } from "@ant-design/icons";

import React, { FC } from "react";

interface ProductSGSalesIncomeProps {
  is_active: boolean;
}

const ProductSGSalesIncome: FC<ProductSGSalesIncomeProps> = ({ is_active }) => {
  return (
 
    <FormWrapper>
      <Form.Item
        label="กำไรและราคาแนะนำ (Business Guide)"
        name="sg_sales_income"
        //rules={[{ required: is_active, message: "กรุณากรอกส่วนของรายได้เซลล์" }]}
        tooltip={{
          title: <TooltipContent />,
          icon: <InfoCircleOutlined />,
          color: "#ffffff",
        }}

      >
        <TextArea  placeholder="กำไรและราคาแนะนำ (Business Guide) ช่วยให้ตัวแทนวางแผนได้" showCount maxLength={5000}  rows={10} />
      </Form.Item>
    </FormWrapper>

  );
};

const TooltipContent = () => {
  return (
    <div style={{ width: "100%" }}>
      <h6 style={{ color: "black" }}>ตัวอย่าง "กำไรและราคาแนะนำ (Business Guide)"</h6>
      <p style={{ color: "black" }}>
        1. ราคา 1 โหล (12 ขวด) โดย 
      </p>
      <p style={{ color: "black" }}>
        a. ราคาตัวแทนจะอยู่ที่ประมาณ 15% ต่อการขาย 1 ลัง
        </p>
      <p style={{ color: "black" }}>
        b. ราคาส่งจะอยู่ที่ 240 บาท/@20 ต่อ ขวด 
        </p> 
              <p style={{ color: "black" }}>
        c. ราคาตลาดจะอยู่ที่ 420 บาท/@35 ต่อ ขวด
        </p>        
           <p style={{ color: "black" }}>
        2. ถ้าเซลล์ชุมชนสามารถ
ขายได้ 2 ลัง/ 1 ร้านค้า จะมีรายได้ 72 บาทต่อวัน ฉะนั้น ทำ 20 วัน จะขายได้ 1,440 บาท ต่อเดือน 
ขายได้ 2 ลัง/10 ร้านค้า จะมีรายได้ 720 บาทต่อวัน ฉะนั้น ทำ 20 วัน จะขายได้ 14,400 บาท ต่อเดือน
      </p>
 
    </div>
  );
};


export default ProductSGSalesIncome;

const FormWrapper = styled.div`
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  padding: 20px 20px 2px 20px;
  border-radius: 8px;
  margin-bottom: 10px;
`;
